module.exports = __webpack_public_path__ + "media/images/icons/outlined/pay-circle-0a3207dbfe5a0729fafa53d9fab6fb40.svg";